import Component from './Breadcrumbs';

export default Component;
